module.exports = __webpack_public_path__ + "img/floor3_bg.9f1bf905.png";